import React, { useState } from "react";
import "./SectionSetting.scss";
import Switch from "@material-ui/core/Switch";

const SectionSetting = ({ id, setting, handleSetting }) => {
  const renderToggle = (ques, ans) => {
    return (
      <div className="d-flex flex-row section-setting-container-switch">
        <div
          className={`${
            ans === true ? "active-key" : "inactive-key"
          } switch-true`}
          onClick={(e) => {
            handleSetting(ques, true);
          }}
        >
          Yes
        </div>
        <div
          className={`${
            ans === false ? "active-key" : "inactive-key"
          } switch-false`}
          onClick={(e) => {
            handleSetting(ques, false);
          }}
        >
          No
        </div>
      </div>
    );
  };
  return (
    <>
      <div className="d-flex flex-row flex-wrap">
        {setting?.map((obj, index) => {
          return (
            <div className="section-setting-container mx-1" key={index}>
              <p className="my-1 section-setting-heading">{obj.question}</p>
              {renderToggle(obj.question, obj.answer)}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default SectionSetting;
